export const USER_FOLLOWS_IDENTIFIER ='--follows--'
export const USER_EVENTS_IDENTIFIER = '--events--'